import React from "react";
import Icon from "./Icon";
export default function Undo(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M9 14L4 9L9 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20V13C20 11.9391 19.5786 10.9217 18.8284 10.1716C18.0783 9.42143 17.0609 9 16 9H4"
  }));
}
Undo.displayname = "Undo";
//# sourceMappingURL=Undo.js.map